export enum ActivityStatus {
  INACTIVE = 0,
  ACTIVE,
  IN_PROGRESS,
  IN_VISIT,
  HAS_VISIT,
  END_VISIT,
  EXPIRED,
  DENIED,
  PROXY_SWITCH
}
